import { appConfig } from '@/config';
const endpoint = () => new URL('/business-api/registration.php', appConfig.serviceOrigin);
export async function registrationRequest(body) {
  const response = await fetch(endpoint(), body ? {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), credentials: 'omit'
  } : { cache: 'no-store', credentials: 'omit' });
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.ok === false) throw new Error(data.message || '注册服务暂时不可用');
  return data;
}
